import { CircularProgress, Grid, Paper, Typography } from '@mui/material';
import { SiTrackPage } from '../../components/si-track-page';
import { useLoadData } from '../../hooks/useLoadData';
import { ApiResponse } from '../../models/api-response';
import { Icons } from '../../assets/icons';
import { dashboardApiKeyStore } from '../../api/dashboard-api-key-store';
import { NavLink } from 'react-router-dom';
import { ReactElement, useEffect } from 'react';
import { Margin } from '@mui/icons-material';
import { GuardedComponent } from '../../components/guarded-component';
import { UserPermissionName } from '../../models/user-permission-name';
import { isMobile } from 'react-device-detect';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '10px' },
  countStyle: { color: '#0000b5', fontSize: 50 },
  iconImg: { margin: '0' },
};
interface ComponentCell {
  label: string;
  value: any;
  element: ReactElement;
}

const isMobileViewEnabled = process.env.REACT_APP_MOBILE_VIEW_FLAG === 'true';

const ComponentCell = ({ label, value, element }: ComponentCell) => {
  return (
    <Paper elevation={0} style={styling.paperStyle}>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item display={'flex'}>
          <Grid container justifyContent="flex-start" flexDirection={'column'} alignItems="flex-start">
            <Typography variant="body1" color="text.secondary" className="d-flex flex-column">
              <span className="dashIcons">{element}</span>
              <label>{label}</label>
            </Typography>
          </Grid>
        </Grid>
        <Grid item display={'flex'}>
          <Grid container justifyContent="flex-end" alignItems="flex-end">
            <Typography variant="h4" style={styling.countStyle}>
              {value}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export const Dashboard = () => {
  const { data, isError, isLoading } = useLoadData<ApiResponse<any>>(dashboardApiKeyStore.getDashboardCount());
  const isPlanEnabled = process.env.REACT_APP_PLAN_FLAG === 'true';
  return (
    <SiTrackPage isLoading={isLoading} title="Dashboard" hideBreadcrumb hideBackNav>
      <div hidden={isMobile && isMobileViewEnabled}>
        <Grid container spacing={2} className="detailsBoxContainer">
          <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_CUSTOMER]}>
            <Grid item xl={4} lg={4} sm={6} xs={6} className="detailsBox">
              <NavLink to="/customers" className="navLink navCustomer">
                <ComponentCell
                  label="CUSTOMERS"
                  value={data?.data.customerCount}
                  element={<img src={Icons.Cutomer} alt="Cutomer" style={styling.iconImg} />}
                />
              </NavLink>
            </Grid>
          </GuardedComponent>
          <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_OFFICE]}>
            <Grid item xl={4} lg={4} sm={6} xs={6} className="detailsBox">
              <NavLink to="/offices" className="navLink navOffices">
                <ComponentCell
                  label="OFFICES"
                  value={data?.data.officeCount}
                  element={<img src={Icons.OfficeDetails} alt="Office" style={styling.iconImg} />}
                />
              </NavLink>
            </Grid>
          </GuardedComponent>
          <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_PROJECT]}>
            <Grid item xl={4} lg={4} sm={6} xs={6} className="detailsBox">
              <NavLink to="/projects" className="navLink navProjects">
                <ComponentCell
                  label="PROJECTS"
                  value={data?.data.projectCount}
                  element={<img src={Icons.Project} alt="Projects" style={styling.iconImg} />}
                />
              </NavLink>
            </Grid>
          </GuardedComponent>
          <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_UNIT]}>
            <Grid item xl={4} lg={4} sm={6} xs={6} className="detailsBox">
              <NavLink to="/units" className="navLink navUnits">
                <ComponentCell
                  label="LOTS/UNITS"
                  value={data?.data.unitCount}
                  element={<img src={Icons.Units} alt="Units" style={styling.iconImg} />}
                />
              </NavLink>
            </Grid>
          </GuardedComponent>
          <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_PLAN]}>
            {isPlanEnabled && (
              <Grid item xl={4} lg={4} sm={6} xs={6} className="detailsBox">
                <NavLink to="/plan-library" className="navLink navPlanLibrary">
                  <ComponentCell
                    label="PLANS"
                    value={data?.data.planCount}
                    element={<img src={Icons.PlanLibrary} alt="Plans" style={styling.iconImg} />}
                  />
                </NavLink>
              </Grid>
            )}
          </GuardedComponent>
          <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_WORKORDER]}>
            <Grid item xl={4} lg={4} sm={6} xs={6} className="detailsBox">
              <NavLink to="/workorders" className="navLink navWorkOrders">
                <ComponentCell
                  label="WORK ORDERS"
                  value={data?.data.workOrderCount}
                  element={<img src={Icons.workorder} alt="WOrk Orders" style={styling.iconImg} />}
                />
              </NavLink>
            </Grid>
          </GuardedComponent>
        </Grid>
      </div>
    </SiTrackPage>
  );
};
